<template>
  <div class="not-found"
       :style="{ height: `calc(100vh - ${headerHeight}px)` }">
    <div class="not-found-wrap">
      <h2>Page not found.</h2>
      <p>{{ $t('system.pageNotFound') }}</p>
      <div class="buttons">
        <button class="btn_1"
                v-if="userData"
                @click="goDashboard">
          Dashboard
        </button>
        <button class="btn_1"
                v-else
                @click="goSignin">
          Sign In
        </button>
        <button class="btn_3"
                @click="goBack">
          <i class="icon icon--back"></i>
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'NotFound',
  computed: {
    ...mapState(['headerHeight']),
    ...mapGetters(['userData'])
  },
  methods: {
    goDashboard () {
      this.$router.push({ name: 'Main' })
    },
    goSignin () {
      this.$router.push({ name: 'SignIn' })
    },
    goBack () {
      window.history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found {
  background-color: #151515;

  .not-found-wrap {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
  }

  h2 {
    text-align: center;
    font-size: 60px;
    font-weight: bold;
    line-height: 1;
    color: #ffffff;
    margin-bottom: 10px;
  }

  p {
    font-size: 37.5px;
    margin-left: 4px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    color: #666666;
  }

  .buttons {
    text-align: center;
    margin-top: 40px;

    button {
      padding: 0 20px;

      .icon {
        margin-left: -10px;
        margin-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/NotFound.vue